// Emit separate SVG assets so browsers fetch only flags that are displayed.
const flagSources = import.meta.glob<string>(
  "/node_modules/country-flag-icons/3x2/*.svg",
  { eager: true, import: "default", query: "?url&no-inline" },
);

export function CountryFlag({ code, className }: { code: string; className: string }) {
  const source = flagSources[`/node_modules/country-flag-icons/3x2/${code}.svg`];
  return (
    <span
      aria-hidden="true"
      className={className}
      style={{
        display: "inline-block",
        backgroundSize: "cover",
        backgroundImage: source ? `url("${source}")` : undefined,
      }}
    />
  );
}
